webpackJsonp([12],{

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _ajax_handler = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class LowestPriceHandler
 */
var LowestPriceHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function LowestPriceHandler() {
    _classCallCheck(this, LowestPriceHandler);

    this._listenSendQuestion();
  }
  /**
   * @private
   */


  _createClass(LowestPriceHandler, [{
    key: "_listenSendQuestion",
    value: function _listenSendQuestion() {
      var button = $('#submit-info-mail');
      button.on('click', function (e) {
        e.preventDefault();
        button.attr("disabled", true);
        var modal = $('#infoMailModal'),
            mailData = {
          sender: $('#name').val(),
          mail: $('#email').val(),
          title: $('#subject').val(),
          message: $('#message').val()
        };

        _ajax_handler.default.post('question', mailData).then(function (response) {
          if (response.success) {
            $('#name').val(null);
            $('#email').val(null);
            $('#subject').val(null);
            $('#message').val(null);
            var html = '<div class="modal-header"><h5 class="modal-title" id="exampleModalLabel">Email poslat</h5></div>' + '<div class="modal-body"><p>Vaše pitanje je uspešno poslato.</p></div>' + '<div class="modal-footer"><button id="infoModalClose" type="button" class="btn btn-primary" data-dismiss="modal">Zatvori</button></div>';
            modal.find('.modal-content').html(html);
            modal.modal();
          }

          button.attr("disabled", false);
        });
      });
    }
  }]);

  return LowestPriceHandler;
}();
/** Start ProductSingleHandler */


$(document).ready(function () {
  new LowestPriceHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[286]);


// WEBPACK FOOTER //
// frontoffice_lowest_price.js